import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDhl = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			rx: 16,
			fill: "#FFCB05"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.11164 14.08L6.24023 15.246H10.9904C11.2305 15.246 11.2271 15.336 11.1102 15.4923C10.9909 15.651 10.7917 15.9277 10.6704 16.0888C10.6088 16.1708 10.4977 16.32 10.8667 16.32H12.8093C12.8093 16.32 13.1225 15.9007 13.3847 15.5497C13.7418 15.0726 13.4155 14.08 12.1395 14.08H7.11261H7.11164Z",
			fill: "#D71635"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.91992 17.92L7.6533 15.52C7.6533 15.52 9.57488 15.52 9.80453 15.52C10.0342 15.52 10.039 15.6123 9.92317 15.7725C9.80501 15.9352 9.60442 16.2158 9.48435 16.3809C9.42336 16.4649 9.31282 16.6178 9.67827 16.6178H12.5599C12.3203 16.9523 11.5427 17.92 10.1471 17.92H5.9204H5.91992Z",
			fill: "#D71635"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.9195 16.64L14.974 17.92H12.48C12.48 17.92 13.425 16.64 13.426 16.64H15.92H15.9195Z",
			fill: "#D71635"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.7569 16.32H13.6001L15.2838 14.08H17.7999L16.835 15.3644H17.9586L18.924 14.08H21.4401L19.7569 16.32Z",
			fill: "#D71635"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.5196 16.64L18.5734 17.92H16.0801C16.0801 17.92 17.0253 16.64 17.0262 16.64H19.5201H19.5196Z",
			fill: "#D71635"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.31982 17.12H5.99982L5.79871 17.44H2.31982V17.12Z",
			fill: "#D71635"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.31982 16.64H6.39982L6.19694 16.88H2.31982V16.64Z",
			fill: "#D71635"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.31982 17.68H5.67982L5.47641 17.92H2.31982V17.68Z",
			fill: "#D71635"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.5999 17.44H25.9199L26.1218 17.12H29.5999V17.44Z",
			fill: "#D71635"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.6 17.9196L25.52 17.92L25.7222 17.68H29.6V17.9196Z",
			fill: "#D71635"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.5202 16.64H29.5998V16.88H26.3198L26.5202 16.64Z",
			fill: "#D71635"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.8801 14.08L23.2084 16.32H20.5601C20.5601 16.32 22.2322 14.08 22.2332 14.08H24.8801Z",
			fill: "#D71635"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.3142 16.64C20.3142 16.64 20.1314 16.8882 20.0424 17.0075C19.7278 17.4289 20.0058 17.92 21.0318 17.92H25.0505L25.9999 16.64H20.3142Z",
			fill: "#D71635"
		})
	]
});
export default SvgDhl;
